export default __webpack_public_path__ + "static/media/cancel.09453510.svg";